import moment from "moment";

export const formatDateUsingMoment = (dateString: string) => {
  if (!dateString) return "";
  return moment(dateString).format("MMMM YYYY");
};
export function getAbbrNoDot(date: Date): string {
  return date.toLocaleString("en-US", { month: "short" }).replace(".", "");
}

export function generateFiscalYearRanges(
  currentFiscalYearDetails: any,
  years: number[]
): Record<number, string> {
  if (!currentFiscalYearDetails) return {};
  const ranges: Record<number, string> = {};
  const startDate = new Date(currentFiscalYearDetails.startDate);
  const endDate = new Date(currentFiscalYearDetails.endDate);
  const startMonth = startDate.getMonth();
  const startDay = startDate.getDate();
  const endMonth = endDate.getMonth();
  const endDay = endDate.getDate();
  years.forEach((fyYear) => {
    const fyStart = new Date(fyYear - 1, startMonth, startDay);
    const fyEnd = new Date(fyYear, endMonth, endDay);
    const startMonthName = getAbbrNoDot(fyStart);
    const endMonthName = getAbbrNoDot(fyEnd);
    ranges[
      fyYear
    ] = `${startMonthName} ${fyStart.getFullYear()} - ${endMonthName} ${fyEnd.getFullYear()}`;
  });
  return ranges;
}

export function formatShortYearUniversal(
  input: number | string | undefined | null
): string {
  if (!input) return "";
  if (typeof input === "number" || /^\d{4}$/.test(String(input))) {
    const y = typeof input === "string" ? parseInt(input, 10) : input;
    return `'${y % 100 < 10 ? "0" : ""}${y % 100}`;
  }
  const str = String(input).trim();
  if (str.includes(" - ")) {
    const [start, end] = str.split(" - ");
    return `${formatShortYearUniversal(start)} - ${formatShortYearUniversal(
      end
    )}`;
  }
  if (/^[A-Za-z]{3,9} \d{4}$/.test(str)) {
    const [month, year] = str.split(" ");
    return `${month} ${formatShortYearUniversal(year)}`;
  }
  return str;
}
